import React, { useEffect, useRef, useState } from 'react';
import { Navbar } from '../../../components/navbar/Navbar';
import BackButton from '../../../components/button/BackButton';
import Table from '../../../components/table/Table';
import { Button } from '../../../components/button/button';
import axios from 'axios';
import SearchInput from '../../../components/input/SearchInput';
import Input from '../../../components/input/Input';
import * as XLSX from 'xlsx';  // Importer la bibliothèque XLSX
import { BACKEND_URL } from '../../../constants/constant';

function EtatDetailleEncaissementEspece() {

  // Navbar
  const Navbarcontent = (
    <div className='flex justify-between '>
      <div className='text-white '>
       Etat detaillé des encaissements (Espèce)
      </div>
      <div>
        <BackButton to="/SituationRecette"></BackButton>
      </div>
    </div>
  );

  const [recepisse, setRecepisse] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${BACKEND_URL}/recette/getEnregistrementdeclaration`)
      .then((response) => setRecepisse(response.data))
      .catch((error) => console.error(error));
  }, []);

  const filteredData = recepisse.filter((item) => {
    const referenceFiscal = item.reference_fiscal && item.reference_fiscal.toLowerCase().includes(searchTerm.toLowerCase());
    const itemDate = new Date(item.date_creation);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return (
      referenceFiscal &&
      item.type_payment === "Espece" &&
      (!startDate || itemDate >= start) &&
      (!endDate || itemDate <= end)
    );
  });

  const headers = ['N° Récepissé', 'Référence Fiscal',   "Nature Impôt", "montant à payer", "montant à verser", "reste à payer",  "Mode de payment"];
  const formattedData = filteredData.map(item => [
    item.numero_recepisse,
    item.reference_fiscal,       
    item.base_impot,
    item.montant_a_payer,
    item.montant_verser,
    item.reste_a_payer,  
    item.type_payment
  ]);

  // Fonction d'exportation vers Excel
  const exportToExcel = () => {
    const worksheetData = [
      headers, // En-têtes
      ...formattedData // Données formatées
    ];

    // Créer une feuille de calcul
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // Créer un nouveau classeur Excel
    const workbook = XLSX.utils.book_new();
    // Ajouter la feuille de calcul au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Encaissements Espèce");
    // Générer et télécharger le fichier Excel
    XLSX.writeFile(workbook, 'etat_detaille_encaissements_espece.xlsx');
  };

  // Impression 
  const printRef = useRef(null);

  const downloadPDF = () => {
    if (printRef.current) {
      const content = printRef.current.innerHTML;
      const originalContent = document.body.innerHTML;

      // Ajoutez une feuille de style pour l'impression
      const printStyle = document.createElement('style');
      printStyle.innerHTML =
        '@media print { body { visibility: hidden; } .print-content { visibility: visible; } }';
      document.head.appendChild(printStyle);

      document.body.innerHTML = `<div class="print-content">${content}</div>`;

      window.print();

      // Supprimez la feuille de style après l'impression
      document.head.removeChild(printStyle);

      // Restaurez le contenu original après l'impression
      document.body.innerHTML = originalContent;
      window.location.reload();
    }
  };

  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Fonction pour formater la date en "dd/mm/yyyy hh:mm:ss"
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois sont indexés de 0 à 11, donc on ajoute 1
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year} à ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className='bg-[#212122] h-screen w-screen'>
      <Navbar content={Navbarcontent}></Navbar>

      <div className="flex flex-col p-4">
        <div className='flex flex-row'>
          <SearchInput value={searchTerm} className={"mt-8"} placeholder={"Rechercher par référence fiscale"} onChange={(e) => setSearchTerm(e.target.value)}></SearchInput>
          <div className='flex flex-col ml-2'>
            <label className='text-white '>Du</label>
            <Input type='date' className="mt-4" value={startDate} onChange={(e) => setStartDate(e.target.value)}></Input>
          </div>
          <div className='flex flex-col ml-2'>
            <label className='text-white '>Au</label>
            <Input type='date' className="mt-4" value={endDate} onChange={(e) => setEndDate(e.target.value)}></Input>
          </div>
        </div>
        <div ref={printRef} className="h-[400px] p-4">
          <div className="mb-8">
            <h2 className="text-xl text-center text-white font-bold">COMMUNE URBAINE DE MAHAJANGA</h2>
            <div className="mt-4 ml-8">
              <div className='flex flex-row'>
                <p className='text-white'>Mahajanga le, </p>
                <p className='text-white text-lg ml-2'>{formatDate(currentDateTime)}</p>
              </div>
              <p className='text-white'> Voici une description ou une introduction pour le tableau ci-dessous.</p>
            </div>
          </div>
          <div className='flex justify-center'>
            <Table
              headers={headers}
              data={formattedData}
              classTable={"h-[300px]"}
            ></Table>
          </div>
          <div className='flex justify-between'>
            <Button children="Imprimer" onClick={downloadPDF} className="mt-4"></Button>
            <Button children="Exporter en Excel" onClick={exportToExcel} className="mt-4"></Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EtatDetailleEncaissementEspece;
